import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconChevronDownLarge = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M4.477 8.46c.14-.14.312-.21.515-.21a.73.73 0 0 1 .54.21L12 14.93l6.469-6.47c.14-.14.312-.21.515-.21a.73.73 0 0 1 .54.21.74.74 0 0 1 .234.54.74.74 0 0 1-.235.54l-6.632 6.632c-.25.25-.547.375-.891.375s-.64-.125-.89-.375L4.476 9.539A.741.741 0 0 1 4.242 9c0-.203.078-.383.235-.54z" }),
});

export { IconChevronDownLarge };
